import type { RailBranch } from "../../data/rail-branches";
import { branchOffsetY } from "../timeline/rail/RailBranchMotion/motion";
import type { TimelineVertex } from "./vertex-primitives";
import { pushWorldLine, type WorldView } from "./world-to-canvas";

const MARK_HALF_LEN = 18;
const MARK_HALF_WIDTH = 2.8;

export interface CastRailMark {
  x: number;
  y: number;
}

/** One tick on each rail the cast is actually on (follows the fork curve). */
export function castRailMarks(
  branches: readonly RailBranch[],
  axisY: number,
  playheadMs: number,
  centerX: number,
): CastRailMark[] {
  const ys = new Set<number>();
  if (branches.length === 0) {
    ys.add(axisY);
  }
  for (const branch of branches) {
    if (playheadMs < branch.startMs || playheadMs >= branch.endMs) {
      continue;
    }
    ys.add(axisY + branchOffsetY(branch, playheadMs));
  }
  return [...ys].map((y) => ({ x: centerX, y }));
}

export function appendCastRailMarks(
  verts: TimelineVertex[],
  branches: readonly RailBranch[],
  axisY: number,
  playheadMs: number,
  centerX: number,
  view: WorldView,
): void {
  for (const mark of castRailMarks(branches, axisY, playheadMs, centerX)) {
    pushWorldLine(
      verts,
      mark.x,
      mark.y - MARK_HALF_LEN,
      mark.x,
      mark.y + MARK_HALF_LEN,
      view,
      0.35,
      0.78,
      0.82,
      0.96,
      MARK_HALF_WIDTH,
    );
  }
}
